import { CommonModule } from '@angular/common';
import { AfterContentChecked, Component, ContentChildren, Directive, EventEmitter, Input, Output, QueryList, TemplateRef } from '@angular/core';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';

@Directive({ selector: 'ng-template[isgPanelContent]', standalone: true })
export class IsgPanelContent {
  constructor(public templateRef: TemplateRef<any>) { }
}

@Directive({ selector: 'isg-panel', standalone: true })
export class IsgPanel implements AfterContentChecked {
  @Input() disabled = false;
  @Input() id = "isg-panel-${nextId++}";
  @Input() title: string = "Unset Title";
  
  _expanded: boolean=false;
  get expanded(): boolean {
    return this._expanded;
  }
  @Input() set expanded(value: boolean) {
    this._expanded = value;
    this.expandedChange.emit(this.expanded);
  }



  contentPnl?: IsgPanelContent;

  @ContentChildren(IsgPanelContent, { descendants: false }) contentPnls: QueryList<IsgPanelContent>= new QueryList<IsgPanelContent>();

  @Output() expandedChange = new EventEmitter<boolean>();

  ngAfterContentChecked() {
    this.contentPnl = this.contentPnls.first;   
  }
  }

@Component({
  selector: 'isg-accordion',
  standalone: true,
  imports: [CommonModule, NgbCollapseModule],
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss']
})
export class AccordionComponent {
  @ContentChildren(IsgPanel) panels: QueryList<IsgPanel> = new QueryList<IsgPanel>();
  expanded: boolean = false;  
  @Input() width?: string;
  @Input() size: string = "medium";
  accordionScroll: boolean = true;


  getStyle() {
    return this.width ? "width:" + this.width : null;
  }

  togglePanel(panel: IsgPanel) {
    setTimeout(() => {
      panel.expanded = !panel.expanded;
    });
  }
}


